module.exports = __webpack_public_path__ + "assets/img/KS8226-M.d326e65e.png";